import { EventBus } from '../../../../core/shared/helpers/EventHelper';
import ItemComponent from '../../../../core/infraestructure/ItemComponent';
import SimulatorQuestionCategoryViewModel from '../../../../core/features/setting/viewmodels/SimulatorQuestionCategoryViewModel';

export default {
    extends: ItemComponent,
    data() {
        return {
            modulePermissions: 'Settings-Careers',
            viewModel: null,
            permissions: null,
            modules: [],
            rules: {
                code: [
                    { required: true, message: 'Código requerido.', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: 'Nombre requerido.', trigger: 'blur' }
                ],
            }
        }
    },
    props: {
        conf: {
            type: Object,
            required: true
        },
        formData: {
            type: Object,
            required: true
        }
    },
    created() {
        this.viewModel = new SimulatorQuestionCategoryViewModel(this)
        this.viewModel.bindFormView(this.formData)
    },
    mounted() { },
    methods: {
        onActive(response) {

        },
        onSubmitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.onSave(this.formData)
                }
            });
        },
        onCanSaveOrUpdate() {
            return this.canCreate(this.modulePermissions) || this.canUpdate(this.modulePermissions)
        },
        onSaveResponse(response) {
            this.showLoading(false, '');
            this.onShowSuccess(response.message);
            this.showComponent(false);
            EventBus.$emit('onSubmitedSimulatorQuestionCategory', null);
        }
    }
}